import { render, staticRenderFns } from "./NewDevice.vue?vue&type=template&id=ec65f42c&scoped=true&"
import script from "./NewDevice.vue?vue&type=script&lang=js&"
export * from "./NewDevice.vue?vue&type=script&lang=js&"
import style0 from "./NewDevice.vue?vue&type=style&index=0&id=ec65f42c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec65f42c",
  null
  
)

export default component.exports